
import ErrorHandlingAction from './responseHandling.types'


export const doError = (payload, module, act, isLogOut=0) => ({
  type: ErrorHandlingAction.SET_ERROR,
  payload,
  module,
  act,
  isLogOut
})

export const doSuccess = (payload, module, act) => ({
  type: ErrorHandlingAction.SET_SUCCESS,
  payload,
  module,
  act
})

export const doWarning = (payload, module, act, isLogOut = 0) => ({
  type: ErrorHandlingAction.SET_WARNING,
  payload,
  module,
  act,
  isLogOut,
});
